import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isUndefined from "lodash/isUndefined";
import _omitBy from "lodash/omitBy";
import _isNumber from "lodash/isNumber";
var _excluded = ["marketplaceEntity", "ratingTextHref", "starRating"];
import React from 'react';
import PropTypes from 'prop-types';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { getLearnMoreLink, getProductType, getStarRating } from '@nerdwallet/marketplace/selectors/common';
import BaseMarketplaceStarRating from './base-marketplace-star-rating'; // export for testing

export var getMappedProps = function getMappedProps(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      ratingTextHref = _ref.ratingTextHref,
      starRating = _ref.starRating,
      props = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread({
    marketplaceEntity: marketplaceEntity,
    productType: getProductType(marketplaceEntity),
    ratingTextHref: ratingTextHref || getLearnMoreLink(marketplaceEntity),
    // Check isNumber to bypass 0 evaluating as falsy
    starRating: _isNumber(starRating) ? starRating : getStarRating(marketplaceEntity)
  }, _omitBy(props, function (val) {
    return _isUndefined(val);
  }));
};

var MarketplaceStarRating = function MarketplaceStarRating(props) {
  useDeprecatedPropsWarning({
    component: 'MarketplaceStarRating',
    deprecatedProps: [{
      version: '2.11.0',
      deprecated: 'enableAnalytics',
      migration: 'use analytics instead'
    }],
    props: props
  });
  return /*#__PURE__*/React.createElement(BaseMarketplaceStarRating, getMappedProps(props));
};

MarketplaceStarRating.propTypes = _objectSpread(_objectSpread({}, BaseMarketplaceStarRating.propTypes), {}, {
  /** Marketplace entity to render. */
  marketplaceEntity: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types

});
export default MarketplaceStarRating;